export default __webpack_public_path__ + "static/grayscale-41a046fad430abeeff4551e7d3c098d6.png";